import React, { Component } from 'react';
import './Dice.css';
import { getRandomInt } from './util';

class WarHammerDie extends Component {
  roll() {
    return this.constructor.options[getRandomInt(0, this.constructor.options.length - 1)];
  }

  render() {
    return (
      <div className="dice_eot_die">
        <img
          src={`/diceImages/warhammer/${this.constructor.type}.png`}
          alt={this.constructor.type} width="30"
        />
      </div>
    )
  }
}

/* ~~ Dice symbol key ~~~~~~~~~~~~~~~~~
 * (B)ane   (D)elay     s(T)ar.png
 * b(O)on   (S)uccess   c(H)allenge
 * (C)omet  (E)xertion  (R)ighteous.png
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
export class WarHammerChallenge extends WarHammerDie {
  static type = 'challenge';
  static options = ['H', 'H', 'HH', 'HH', 'B', 'BB', 'T', ''];
}
export class WarHammerExpertise extends WarHammerDie {
  static type = 'expertise';
  static options = ['S', 'R', 'O', 'O', 'C', ''];
}
export class WarHammerReckless extends WarHammerDie {
  static type = 'reckless';
  static options = ['SS', 'SS', 'SO', 'OO', 'ES', 'ES', 'B', 'B', '', ''];
}
export class WarHammerCharacteristic extends WarHammerDie {
  static type = 'characteristic';
  static options = ['S', 'S', 'S', 'S', '', '', 'O', 'O'];
}
export class WarHammerFortune extends WarHammerDie {
  static type = 'fortune';
  static options = ['S', 'S', 'O', '', '', ''];
}
export class WarHammerConservative extends WarHammerDie {
  static type = 'conservative';
  static options = ['S', 'S', 'S', 'S', 'O', 'O', 'SO', 'DS', 'DS', ''];
}
export class WarHammerMisfortune extends WarHammerDie {
  static type = 'misfortune';
  static options = ['H', 'H', 'B', '', '', ''];
}



// WEBPACK FOOTER //
// ./src/Dice/WarHammerDie.js